import { getToken, setToken, removeToken } from '@/utils/auth'
//import { login } from '@/api/login'

const user = {
    state: {
        token: getToken(),
        user: {}
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, user) => {
            state.user = user;
        }
    },
    actions: {
     //    Login({ commit }, userInfo) {
     //        return new Promise((resolve, reject) => {
     //            login(userInfo).then((res) => {
     //                //console.log(res);
					// if(res.code == 200){
					// 	commit('SET_TOKEN', res.data.token);
					// 	commit('SET_USER', res.data);
					// }
     //                resolve(res);
     //            }).catch((error) => {
     //                reject(error);
     //            });
     //        })
     //    }
    }
};

export default user